export var InitializationStatus;
(function(InitializationStatus) {
    /**
   * We're still waiting on something (e.g. code to execute, network request to finish)
   */ InitializationStatus["Initializing"] = "initializing";
    /**
   * Initialized and ready to go!
   */ InitializationStatus["Success"] = "success";
    /**
   * Most likely we failed to load a resource due to a network issue.
   */ InitializationStatus["Failure"] = "failure";
})(InitializationStatus || (InitializationStatus = {}));
export const moderationCaseTypes = {
    mature: 'Mature',
    copyright: 'Copyright Violation',
    policy: 'Policy Violation',
    miscat: 'Miscategorization',
    pornography: 'Content Violation',
    underage: 'Underage Sexualized Content',
    malware: 'Malware',
    warez: 'Warez',
    virus: 'Virus',
    password: 'Password',
    premium: 'Premium Content Issue',
    spam: 'Spam',
    alarming: 'Alarming',
    abuse: 'Abuse',
    copyright_thirdparty: 'Third Party Copyright Violation'
};
export var FeedbackModalType;
(function(FeedbackModalType) {
    FeedbackModalType["CORRESPONDENCE"] = "CORRESPONDENCE";
})(FeedbackModalType || (FeedbackModalType = {}));

//# sourceMappingURL=index.js.map